import { render, staticRenderFns } from "./EditOptionGroup.vue?vue&type=template&id=a6e44bae"
import script from "./EditOptionGroup.vue?vue&type=script&lang=js"
export * from "./EditOptionGroup.vue?vue&type=script&lang=js"
import style0 from "./EditOptionGroup.vue?vue&type=style&index=0&id=a6e44bae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports